


































import { Component, Vue } from 'vue-property-decorator'
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/Auth/AppModule';

@Component({ name: 'Sso' })
export default class extends Vue {

    hasError: boolean = false;
    errorMessage: string = "";

    async beforeMount() {

        // Get the query string params we need
        var redirectPath = this.$route.query.RedirectPath;

        await ajax.get("/portal-backend/document360/auth?redirectPath=" + redirectPath)
            .then(response => {
            window.location.href = response.data.redirect;
        })
        .catch(error => {
            this.hasError = true;
            this.errorMessage = error.message;
            AppModule.handleApiError(error);
        });
    }

}
